import React from 'react';
import SkeletonTableLoader from './SkeletonTableLoader';

const Table = ({ headers, rows, loading }) => {
  return (
    <div className="w-full overflow-auto rounded-lg border border-border bg-card">
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr className="bg-muted/60 text-left">
            {headers.map((header, index) => (
              <th
                key={index}
                className="h-9 whitespace-nowrap px-3 text-[11px] font-medium uppercase tracking-wide text-muted-foreground"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        {loading ? (
          <SkeletonTableLoader numCols={headers.length} />
        ) : (
          <tbody className="divide-y divide-border">
            {rows.map((row, index) => (
              <tr
                key={index}
                className="transition-colors hover:bg-muted/40"
              >
                {row.map((cell, j) => (
                  <td key={j} className="px-3 py-2.5 align-middle text-foreground">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default Table;
